export default __webpack_public_path__ + "static/media/Group -3@2x.56ec7ea1.png";